import React from 'react';
import { browserHistory } from 'react-router';
import TextCell from './TextCell';
import SortHeaderCell from './SortHeaderCell';
import { Cell, Column, Table } from 'fixed-data-table';
import * as actions from '../redux/actions';
import DataTableUtil from '../DataTableUtil';
import Storage from '../Storage';
import { SortTypes } from '../Constants';
import BaseLayout from './pages/BaseLayout';
import Api from '../Api.js';
import { ModalContainer, ModalDialog } from 'react-modal-dialog';
import XpressTemplateView from './XpressTemplateView';

const FILTER_COLUMNS = ['name', 'type', 'description'];
const DEFAULT_COL_SORT_DIRS = { name: SortTypes.DESC };
const DEFAULT_TABLE_WIDTH = 1200;
const DEFAULT_TABLE_HEIGHT = 500;

function getFilterKey(tableTitle = 'XpressTemplateTable') {
  return tableTitle + ' : filterText';
}

function getColSortKey(tableTitle = 'XpressTemplateTable') {
  return tableTitle + ' : columnSortDirs';
}

class XpressTemplateTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filterText: Storage.getSessionItem(getFilterKey(props.tableTitle)) || '',
      columnSortDirs:
        Storage.getSessionItem(getColSortKey(props.tableTitle)) || DEFAULT_COL_SORT_DIRS,
      selectedTemplate: {},
    };

    this.handleSortChange = this.handleSortChange.bind(this);
    this.handleFilter = this.handleFilter.bind(this);
    this.handleXTemplateCreate = this.handleXTemplateCreate.bind(this);
    this.handleXTemplateDelete = this.handleXTemplateDelete.bind(this);
    this.handleXTemplateApply = this.handleXTemplateApply.bind(this);
    this.handleShowTemplateViewModal = this.handleShowTemplateViewModal.bind(this);
    this.handleHideTemplateViewModal = this.handleHideTemplateViewModal.bind(this);
  }

  componentDidMount() {
    let { dispatch } = this.props;
    dispatch(actions.getXpressTemplateList());
  }

  handleSortChange(columnKey, sortDir) {
    let value = { [columnKey]: sortDir };
    this.setState({ columnSortDirs: value }, () => {
      Storage.setSessionItem(getColSortKey(this.props.tableTitle), value);
    });
  }

  handleFilter(e) {
    if (!e.target.value) {
      this.setState({ filterText: '' }, () => {
        Storage.setSessionItem(getFilterKey(this.props.tableTitle), '');
      });
      return;
    }

    const filterBy = this.refs.filterInput.value.toLowerCase();
    this.setState({ filterText: filterBy }, () => {
      Storage.setSessionItem(getFilterKey(this.props.tableTitle), filterBy);
    });
  }

  handleXTemplateDelete(template) {
    let isYes = window.confirm('Delete ' + template.name + '?');
    if (isYes) {
      let { dispatch } = this.props;
      Api.deleteXTemplate(template).then(() => {
        dispatch(actions.getXpressTemplateList());
        // alert("Deleted: " + template.name)
      });
    }
  }

  handleXTemplateCreate() {
    browserHistory.push({ pathname: '/admin/xpresstemplates/create' });
  }

  handleXTemplateApply(template) {
    browserHistory.push({
      pathname: '/admin/xpresstemplates/apply/' + template.id,
    });
  }

  handleShowTemplateViewModal(selectedTemplate) {
    this.setState({ selectedTemplate });
  }

  handleHideTemplateViewModal() {
    this.setState({ selectedTemplate: {} });
  }

  render() {
    const { filterText, columnSortDirs, selectedTemplate } = this.state;
    const { xpressTemplateList } = this.props;

    const dataList = DataTableUtil.filterList(
      xpressTemplateList,
      filterText,
      FILTER_COLUMNS,
      columnSortDirs
    );
    const size = xpressTemplateList.length;

    let tableWidth = this.props.tableWidth || DEFAULT_TABLE_WIDTH;
    let tableHeight = BaseLayout.calcTableHeight(xpressTemplateList) || DEFAULT_TABLE_HEIGHT;

    return (
      <div>
        {selectedTemplate && selectedTemplate.id && (
          <ModalContainer onClose={this.handleHideTemplateViewModal}>
            <ModalDialog onClose={this.handleHideTemplateViewModal}>
              <XpressTemplateView template={selectedTemplate} />
            </ModalDialog>
          </ModalContainer>
        )}
        <div style={{ display: 'block', margin: '20px auto', width: tableWidth }}>
          <div className='pure-g pure-u-1 card-label button-secondary'>
            <button
              className='pure-button button-title button-aux'
              onClick={this.handleXTemplateCreate}
            >
              <i className='fa fa-fw fa-plus' />
            </button>
            <i className='fa fa-fw fa-files-o' />
            {this.props.tableTitle}
            <input
              className='table-search'
              type='search'
              placeholder='Search'
              ref='filterInput'
              value={filterText}
              onChange={this.handleFilter}
            />
          </div>
          <Table
            rowsCount={dataList.length}
            rowHeight={50}
            headerHeight={50}
            width={tableWidth}
            height={tableHeight}
            {...this.props}
          >
            <Column
              header={<Cell>#</Cell>}
              cell={(props) => (
                <Cell {...props}>
                  <span style={{ fontSize: 10 }}>{props.rowIndex + 1}</span>
                </Cell>
              )}
              fixed={true}
              width={30}
              align='right'
            />
            <Column
              columnKey='name'
              header={
                <SortHeaderCell onSortChange={this.handleSortChange} sortDir={columnSortDirs.name}>
                  Template Name
                </SortHeaderCell>
              }
              cell={(props) => (
                <Cell {...props} className='main-cell' style={{ color: 'black' }}>
                  <a
                    href='javascript:void(0)'
                    onClick={this.handleShowTemplateViewModal.bind(this, dataList[props.rowIndex])}
                  >
                    {dataList[props.rowIndex].name}
                  </a>
                </Cell>
              )}
              fixed={true}
              width={300}
            />
            <Column
              columnKey='type'
              header={
                <SortHeaderCell onSortChange={this.handleSortChange} sortDir={columnSortDirs.type}>
                  Type
                </SortHeaderCell>
              }
              cell={<TextCell dataList={dataList} field='type' />}
              fixed={true}
              width={200}
            />
            <Column
              columnKey='description'
              header={
                <SortHeaderCell
                  onSortChange={this.handleSortChange}
                  sortDir={columnSortDirs.description}
                >
                  Description
                </SortHeaderCell>
              }
              cell={<TextCell dataList={dataList} field='description' />}
              fixed={true}
              width={500}
            />
            <Column
              columnKey='actions'
              header={<SortHeaderCell>Actions</SortHeaderCell>}
              cell={(props) => (
                <Cell {...props}>
                  <a
                    style={{ fontSize: '150%', margin: '10px', cursor: 'pointer' }}
                    className='fa fa-trash-o '
                    title='Delete'
                    onClick={() => {
                      this.handleXTemplateDelete(dataList[props.rowIndex]);
                    }}
                  />
                  <a
                    style={{ fontSize: '150%', margin: '10px', cursor: 'pointer' }}
                    className='fa fa-share'
                    title='Apply to kiosk'
                    onClick={() => {
                      this.handleXTemplateApply(dataList[props.rowIndex]);
                    }}
                  />
                </Cell>
              )}
              width={170}
            />
          </Table>
          <div className='pure-g' style={{ padding: '5px 0' }}>
            <div className='pure-u-1-3'>
              {dataList.length < size ? (
                <span>
                  Showing {dataList.length} entries (filtered from {size} total entries)
                </span>
              ) : (
                <span>
                  Showing {dataList.length} of {size}
                </span>
              )}
            </div>
            <div className='pure-u-1-3'></div>
            <div className='pure-u-1-3' style={{ textAlign: 'right' }}></div>
          </div>
        </div>
      </div>
    );
  }
}

export default XpressTemplateTable;



// WEBPACK FOOTER //
// ./src/components/XpressTemplateTable.js